import React from "react";

export default function MicrophoneIcon({ className }) {
  return (
    <>
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        <g clipPath="url(#clip0_790_2716)">
          <path
            d="M15.75 6.5C15.75 4.42893 14.0711 2.75 12 2.75C9.92893 2.75 8.25 4.42893 8.25 6.5V12.5C8.25 14.5711 9.92893 16.25 12 16.25C14.0711 16.25 15.75 14.5711 15.75 12.5V6.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 19.25V23"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.75 12.5C18.75 14.2902 18.0388 16.0071 16.773 17.273C15.5071 18.5388 13.7902 19.25 12 19.25C10.2098 19.25 8.4929 18.5388 7.22703 17.273C5.96116 16.0071 5.25 14.2902 5.25 12.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_790_2716">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
